import { Splash } from "@openanalyst-ai/ui/logo"
import { Show } from "solid-js"

export function AppLoading(props: { message?: string; class?: string; scope?: "screen" | "panel" }) {
  const message = () => props.message?.trim()
  const scope = () => props.scope ?? "screen"
  const sizing = () => (scope() === "panel" ? "size-full min-h-0 min-w-0" : "fixed inset-0 z-50")

  return (
    <div
      data-app-loading-scope={scope()}
      class={`${sizing()} flex flex-col items-center justify-center bg-background-base text-text-base ${props.class ?? ""}`}
      aria-busy="true"
    >
      <div class="flex flex-col items-center gap-4">
        <Splash class="size-16 opacity-75 animate-pulse" />
        <Show when={message()}>
          <div class="text-13-regular text-text-weak">{message()}</div>
        </Show>
      </div>
    </div>
  )
}
